import { assign, createMachine } from 'xstate';

export const enum AuthFormMachineEventEnum {
  EMAIL_EXISTS = 'EMAIL_EXISTS',
  EMAIL_DOES_NOT_EXIST = 'EMAIL_DOES_NOT_EXIST',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  SIGNUP_FORM_VALID = 'SIGNUP_FORM_VALID',
  RESEND_TOKEN = 'RESEND_TOKEN',
  TOKEN_VERIFIED = 'TOKEN_VERIFIED',
  SUCCESS = 'SUCCESS',
  BACK = 'BACK',
  RESET_EMAIL_SENT = 'RESET_EMAIL_SENT',
}

export interface UserContext {
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  password?: string;
  marketing?: boolean;
}

interface MachineContext {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  password?: string;
  marketing?: boolean;
  verificationId?: string;
}

type MachineEvent =
  | {
      type:
        | AuthFormMachineEventEnum.EMAIL_EXISTS
        | AuthFormMachineEventEnum.EMAIL_DOES_NOT_EXIST
        | AuthFormMachineEventEnum.FORGOT_PASSWORD
        | AuthFormMachineEventEnum.RESET_EMAIL_SENT;
      email: string;
    }
  | {
      type: AuthFormMachineEventEnum.SIGNUP_FORM_VALID;
      firstName: string;
      lastName: string;
      phone: string;
      password: string;
      marketing: boolean;
      verificationId: string;
    }
  | {
      type: AuthFormMachineEventEnum.RESEND_TOKEN;
      verificationId: string;
    }
  | {
      type: AuthFormMachineEventEnum.BACK | AuthFormMachineEventEnum.TOKEN_VERIFIED | AuthFormMachineEventEnum.SUCCESS;
    };

export const enum AuthFormMachineStateEnum {
  START = 'start',
  SIGNIN = 'signin',
  SIGNUP_PERSONAL_DETAILS = 'signupPersonalDetails',
  SIGNUP_TOKEN_VERIFICATION = 'signupTokenVerification',
  SIGNUP_SUCCESSFUL = 'signupSuccessful',
  RESET_PASSWORD = 'resetPassword',
  RESET_PASSWORD_CONFIRMATION = 'resetPasswordConfirmation',
  END = 'end',
}

type MachineTypestate =
  | { value: AuthFormMachineStateEnum.START; context: MachineContext }
  | {
      value:
        | AuthFormMachineStateEnum.SIGNIN
        | AuthFormMachineStateEnum.SIGNUP_PERSONAL_DETAILS
        | AuthFormMachineStateEnum.RESET_PASSWORD
        | AuthFormMachineStateEnum.RESET_PASSWORD_CONFIRMATION;
      context: MachineContext & { email: string };
    }
  | {
      value: AuthFormMachineStateEnum.SIGNUP_TOKEN_VERIFICATION | AuthFormMachineStateEnum.SIGNUP_SUCCESSFUL;
      context: MachineContext & {
        email: string;
        firstName: string;
        lastName: string;
        phone: string;
        password: string;
        marketing: boolean;
        verificationId: string;
      };
    };

export const authFormMachine =
  /** @xstate-layout N4IgpgJg5mDOIC5QAoC2BDAxgCwJYDswBKAOlgBd0AncgYgFEBZAQQEkAZAfXoA1WBlACr8A2gAYAuolAAHAPaxc5XHPzSQAD0QAmAOwBmEgA59ugJxiArJYBsN-Zd1GANCACeOszZJOAjGLNtABYHGzEHAF8I1zQsPEJSCmo6JjYuABEAeXp+TgA5TMFuPiFxKSQQeUVlVXUtBG0HEgddEKNLMW0bIKDO1w8EIN9vXyMgs1HdKfDtbSiYjBwCYjJcKHwCWn4AVQBhXZzRSXUqpRU1CvqbIzMSbUt2i19LIIeh-p0TEg6xX8th0avGzzECxJYJVbrTYAMUyACUAOKFTgABWY-H4AHV4ekyicFGdapdEN0jCRwmYjLNguZ9L4PghfFMSEFdNoLPoxD1Aa8QWD4itFFD8LQAELMXYAaTxFVONQuoCuuhITJsXjEBiC2iZ+m0DNmZLZ+n0gVMwSM7T5iwFiTW+AArjIUWAqLBVOgADbpMCUXAe2BbVgIvLbFGcWFwxicABqzHYrFxx1lBPldUQBkMugBNgBRg1PQZQxGYwtGrswxslitcWWtvWjudrvdXp96D9AfFUplshT5zTCBsytV6s12oMevciAe3leGqmjiz-2B0VB1trkIdMkEcgA1mB8NGXbgAGa4TDoeViiXSpM96p94kIcy+EhmF4hUxiJlUmwM-Q2bRmheXROl8Lxxl8atwUFO1HW3PcDyPU9z0vOEcnoPJ0k4QRMklDDu0qXsiUVRBfF8Y1jECWxhn+RxLAZJdmkCZ4zECMZZmXBYawhIVN3g-dDyoE8zwvc5aBwvC8hjeg4VYaFWHoRNyjvQkFU0UjGluVpLH0IxRkpACNULE0VRzII7DMcYwnaKsV35ddeMdfh7UwTA4FgY97Q9LY9gODECLlB8SMZbognJbQNVsU1S3oydBhMgFzLVKyxBsqCbRIKg4B9FF0FgWAAHc5CoCBaDQ-h6CKVIOE4Cq8kEAKiLU+oyN6O49F6czrC1awGTIskLX-NUNXZOlWXS9cstgHK8sK4rSs7G9lMI+9iPUp8uWabUxBzXSvDohkANfB4FxNbQqVZSC7LXCEppm-KipK3ZVFPKgMEvRbGtW5rSLAwCbh07SdKZIIGJncipjzQHdEcKIV3wOQIDgdR7ISfFvv7MCVV0NUwlHHUmQZABaOlySMAD2VsSm0uu7jBUoGh0dU-snFfcxKV8V5LEaawJwGY0xBVIZrAmTreiZCaeLtAgmdTR9-mVdiwLzcngmNfV-yA34uUaGHnl8OZaegutN0bN18E9b1fX9WWgvWjowpVsJenOxxUt0YzbkSiyUstI2MscrddwEpCRLllTw-WrxDE5Vl3a1XTrkLIYSHLcyv0HQIeslmD6xkZzXPczyPVttaWqBb5zGuHoovsFw4pCL2zJ99U-a443Muy8hcoe+bS5+hBye8QyANaOxxj0vrdXJbXOlS-MTV0HPSDu7vZseiBnvwV73rtwKy9IkJwazCwv2eecp8A2e57zVpF+Xkh9wgfvMZA5VrkrADyPsfx64GPRDA6T0O0Z4HQzAgX0HDCIQA */
  createMachine<MachineContext, MachineEvent, MachineTypestate>(
    {
      initial: AuthFormMachineStateEnum.START,
      predictableActionArguments: true,
      context: {
        marketing: true,
      },
      states: {
        [AuthFormMachineStateEnum.START]: {
          on: {
            [AuthFormMachineEventEnum.EMAIL_EXISTS]: {
              target: AuthFormMachineStateEnum.SIGNIN,
              actions: ['addDetails'],
            },
            [AuthFormMachineEventEnum.EMAIL_DOES_NOT_EXIST]: {
              target: AuthFormMachineStateEnum.SIGNUP_PERSONAL_DETAILS,
              actions: ['addDetails'],
            },
          },
        },
        [AuthFormMachineStateEnum.SIGNIN]: {
          on: {
            [AuthFormMachineEventEnum.SUCCESS]: {
              target: AuthFormMachineStateEnum.END,
            },
            [AuthFormMachineEventEnum.FORGOT_PASSWORD]: {
              target: AuthFormMachineStateEnum.RESET_PASSWORD,
            },
            [AuthFormMachineEventEnum.BACK]: {
              target: AuthFormMachineStateEnum.START,
            },
          },
        },
        [AuthFormMachineStateEnum.SIGNUP_PERSONAL_DETAILS]: {
          on: {
            [AuthFormMachineEventEnum.SIGNUP_FORM_VALID]: {
              target: AuthFormMachineStateEnum.SIGNUP_TOKEN_VERIFICATION,
              actions: ['addDetails', 'addVerificationId'],
            },
            [AuthFormMachineEventEnum.BACK]: AuthFormMachineStateEnum.START,
          },
        },
        [AuthFormMachineStateEnum.SIGNUP_TOKEN_VERIFICATION]: {
          on: {
            [AuthFormMachineEventEnum.BACK]: AuthFormMachineStateEnum.SIGNUP_PERSONAL_DETAILS,
            [AuthFormMachineEventEnum.RESEND_TOKEN]: {
              target: AuthFormMachineStateEnum.SIGNUP_TOKEN_VERIFICATION,
              actions: ['addVerificationId'],
            },
            [AuthFormMachineEventEnum.TOKEN_VERIFIED]: AuthFormMachineStateEnum.SIGNUP_SUCCESSFUL,
          },
        },
        [AuthFormMachineStateEnum.SIGNUP_SUCCESSFUL]: {
          on: {
            [AuthFormMachineEventEnum.SUCCESS]: AuthFormMachineStateEnum.END,
          },
        },
        [AuthFormMachineStateEnum.RESET_PASSWORD]: {
          on: {
            [AuthFormMachineEventEnum.RESET_EMAIL_SENT]: {
              actions: ['addDetails'],
              target: AuthFormMachineStateEnum.RESET_PASSWORD_CONFIRMATION,
            },
            [AuthFormMachineEventEnum.BACK]: AuthFormMachineStateEnum.SIGNIN,
          },
        },
        [AuthFormMachineStateEnum.RESET_PASSWORD_CONFIRMATION]: {
          on: {
            [AuthFormMachineEventEnum.BACK]: AuthFormMachineStateEnum.RESET_PASSWORD,
          },
        },
        [AuthFormMachineStateEnum.END]: {
          type: 'final',
          entry: ['onSuccess'],
        },
      },
    },
    {
      actions: {
        addDetails: assign((context, event) => {
          if (
            event.type === AuthFormMachineEventEnum.EMAIL_EXISTS ||
            event.type === AuthFormMachineEventEnum.EMAIL_DOES_NOT_EXIST ||
            event.type === AuthFormMachineEventEnum.RESET_EMAIL_SENT
          ) {
            return {
              ...context,
              email: event.email,
            };
          }
          if (event.type === AuthFormMachineEventEnum.SIGNUP_FORM_VALID) {
            return {
              ...context,
              firstName: event.firstName,
              lastName: event.lastName,
              phone: event.phone,
              password: event.password,
              marketing: event.marketing,
            };
          }
          return context;
        }),
        addVerificationId: assign((context, event) => {
          if (
            event.type === AuthFormMachineEventEnum.SIGNUP_FORM_VALID ||
            event.type === AuthFormMachineEventEnum.RESEND_TOKEN
          ) {
            return {
              ...context,
              verificationId: event.verificationId,
            };
          }

          return context;
        }),
      },
    },
  );
